import { trackEvent } from '@svenskaspelab/nova-core/nextjs/analytics';
import { useEffect, useRef, useState } from 'react';

import { MAX_SESSION_TIME_MINUTES } from '../../../constants.js';
import { useSessionTime } from '../../../store/zustand.js';
import type { ShowDialogFn } from '../../../types.js';
import { trackEventConfig } from '../constants.js';
import showRealityChecksDialog from '../dialogs/realityChecksDialog.js';

export default function useNextHour(showDialog: ShowDialogFn, logout: () => Promise<void>) {
  const [lastShow, setLastShow] = useState<number | null>(new Date(0).getTime()); // init to epoch time
  const isShowingInactivityMessage = useSessionTime((state) => state.isShowingInactivityMessage);
  const isShowingIMRef = useRef(isShowingInactivityMessage);
  useEffect(() => {
    isShowingIMRef.current = isShowingInactivityMessage;
  }, [isShowingInactivityMessage]);

  /**
   * Checks if an hour has passed for player.
   * If the player has been logged in that time, show the player
   * a dialog where the player can log out.
   *
   * @param loggedInMinutes - session time the player has been logged in, in minutes
   */
  const onNextHour = (loggedInMinutes: number) => {
    if (loggedInMinutes > 59 && loggedInMinutes % 60 === 0 && loggedInMinutes < MAX_SESSION_TIME_MINUTES) {
      // only show once every 60 min (not twice)
      if (lastShow === loggedInMinutes) {
        return;
      }
      setLastShow(loggedInMinutes);

      if (isShowingIMRef.current) {
        // Don't stack dialogs, if the inactivity dialog is showing, skip showing the reality check dialog
        return;
      }

      void showDialog(showRealityChecksDialog(loggedInMinutes, logout));

      trackEvent({
        ...trackEventConfig,
        optLabel: 'Dialog shown',
        optValue: loggedInMinutes / 60,
      });
    }
  };

  return onNextHour;
}
